import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { GetInvoiceResponse, InvoiceItem } from '@/service/payment/type';
import { Tables } from '@/types/database.types';
import { formatAPIKey } from '@/utils';
import {
  fCurrencyExtended,
  fCurrencyUSD,
  fCurrencyUSDExtended,
} from '@/utils/formatNumber';
import { fFullDateTime } from '@/utils/formatTime';
import { ArrowTopRightIcon } from '@radix-ui/react-icons';
import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

export const columns: ColumnDef<InvoiceItem>[] = [
  {
    accessorKey: 'invoice_id',
    header: 'Invoice ID',
    cell: ({ row }) => {
      return (
        <Link
          to={row?.original?.stripe_link}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1 underline"
        >
          {row?.original?.invoice_id}
          <ArrowTopRightIcon />
        </Link>
      );
    },
  },
  {
    accessorKey: 'invoice_month',
    header: 'Invoice Month',
    cell: ({ row }) => {
      return dayjs(row.getValue('invoice_month')).format('YYYY-MM');
    },
    size: 100,
  },
  {
    accessorKey: 'cost',
    header: () => <div className="text-right">Cost</div>,
    cell: ({ row }) => {
      return (
        <div className="text-right">
          {fCurrencyUSDExtended(Number(row.getValue('cost')) / 100)}
        </div>
      );
    },
    size: 100,
  },
];
